module.exports = __webpack_public_path__ + "static/media/1.6d9ad418.jpg";